import React from 'react'

const Avatar = (data: any) => {
    return (
            <img className="avatar" src={data.image} alt="kari logo"/>

    )
}

export default Avatar
